import { render, staticRenderFns } from "./partydetails.vue?vue&type=template&id=6daa2eca&scoped=true&"
import script from "./partydetails.vue?vue&type=script&lang=js&"
export * from "./partydetails.vue?vue&type=script&lang=js&"
import style0 from "./partydetails.vue?vue&type=style&index=0&id=6daa2eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daa2eca",
  null
  
)

export default component.exports